(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("7mTCx", function(module, exports) {
const $55d5bb9076f69871$var$forms = document.querySelectorAll("form.f-newsletter");
const $55d5bb9076f69871$var$handleFom = (form)=>{
    const select = form.querySelector(".f-newsletter__shop-select select");
    if (!select) return;
    if (select.value) form.action = select.value;
    select.addEventListener("change", ()=>{
        const { value: value } = select;
        form.action = value;
    });
};
$55d5bb9076f69871$var$forms.forEach((form)=>{
    $55d5bb9076f69871$var$handleFom(form);
});

});

})();
//# sourceMappingURL=newsletter-form.1c8a0661.js.map
